/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ICoordenadas } from 'modelos/src';

import { HelperService } from 'src/app/auxiliares/servicios/helper.service';

@Component({
  selector: 'app-importar',
  templateUrl: './importar.component.html',
  styleUrls: ['./importar.component.scss'],
  standalone: false,
})
export class ImportarComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private dialogRef = inject<MatDialogRef<ImportarComponent>>(MatDialogRef);
  private helper = inject(HelperService);

  public loading = false;
  public form?: UntypedFormGroup;

  //

  private createForm(): void {
    this.form = this.fb.group({
      geojson: ['', [Validators.required]],
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  //
  private getData(): ICoordenadas[][] {
    const parsed = JSON.parse(this.form?.value.geojson);
    const poligonos = this.extraerPoligonos(parsed);
    if (!poligonos.length) {
      throw new Error(
        'El GeoJSON no contiene ningún Polygon ni MultiPolygon válido',
      );
    }
    return poligonos;
  }

  /**
   * Acepta cualquier GeoJSON razonable: FeatureCollection, Feature,
   * GeometryCollection (formato legacy del ejemplo de iotcluster),
   * Polygon o MultiPolygon pelados (lo que devuelven Nominatim y
   * polygons.openstreetmap.fr sin adaptar nada a mano).
   */
  private extraerPoligonos(geojson: any): ICoordenadas[][] {
    if (!geojson || typeof geojson !== 'object') {
      return [];
    }
    switch (geojson.type) {
      case 'FeatureCollection':
        return (geojson.features || []).flatMap((f: any) =>
          this.extraerPoligonos(f),
        );
      case 'Feature':
        return this.extraerPoligonos(geojson.geometry);
      case 'GeometryCollection':
        return (geojson.geometries || []).flatMap((g: any) =>
          this.extraerPoligonos(g),
        );
      case 'Polygon':
        // [anillo][punto][lng,lat] → solo el anillo exterior
        return [this.anilloACoordenadas(geojson.coordinates?.[0])];
      case 'MultiPolygon':
        // [poligono][anillo][punto][lng,lat] → anillo exterior de cada uno
        return (geojson.coordinates || []).map((poly: any) =>
          this.anilloACoordenadas(poly?.[0]),
        );
      default:
        // Legacy: objeto con `geometries` sin type (formato viejo del importador)
        if (Array.isArray(geojson.geometries)) {
          return geojson.geometries.flatMap((g: any) =>
            this.extraerPoligonos({ type: 'MultiPolygon', ...g }),
          );
        }
        return [];
    }
  }

  private anilloACoordenadas(anillo?: [number, number][]): ICoordenadas[] {
    return (anillo || []).map(([lng, lat]) => ({ lat, lng }));
  }

  public async onSubmit(): Promise<void> {
    this.loading = true;
    try {
      const data = this.getData();
      this.dialogRef.close(data);
    } catch (err) {
      console.error(err);
      this.helper.notifError(err);
    }
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    this.createForm();
  }

  async cargarInput(event: any) {
    const file = event.target.files[0];
    const texto = await this.readFileContent(file);
    this.form?.patchValue({
      geojson: texto,
    });
  }

  async readFileContent(file: any): Promise<string> {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = (event) => resolve(event.target?.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsText(file);
    });
  }

}
